import { RoleType, UserEntity } from 'api/types/entity';
import { OperationOrderEntity } from 'api/types/entity/operation';
import { parseFullName, yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import { OperationFormType } from 'modules/operation/common/forms/operationForm';

export const getOperationInitialValue = (
  operationOrder: OperationOrderEntity | null,
  user: UserEntity,
  t: TFunc
): Partial<OperationFormType> => ({
  ...(operationOrder && {
    client: {
      label: `${operationOrder.ownerFullName} (${operationOrder.ownerPersonalAccountNumber})`,
      value: operationOrder.ownerId,
      record: {
        id: operationOrder.ownerId,
        name: operationOrder.ownerFullName || '',
        personalAccountNumber: operationOrder.ownerPersonalAccountNumber || '',
      },
    },
    clientType: {
      label: t(`primaryClientType.${operationOrder.ownerType}`),
      value: operationOrder.ownerType,
    },
    order: {
      value: operationOrder.id,
      label: String(operationOrder.number),
      record: operationOrder,
    },
  }),
  trader:
    user.role?.name === RoleType.FrontOffice
      ? {
          value: user.id,
          label: parseFullName(user),
        }
      : null,
  isSpecializedTrade: yesOrNotOption(t, false),
});
